/**
 * Central HTML sanitizer for the two places we render server-side or
 * AI-produced HTML (release notes preview + public /releases page).
 *
 * Kept as its own module so the sanitizer config lives in ONE spot — if we
 * ever need to allow more tags (e.g. embedded video), we change the allow-list
 * here and both call-sites benefit.
 */
import DOMPurify from "dompurify";

const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "strong", "b", "em", "i", "u", "s",
    "ul", "ol", "li",
    "a", "code", "pre", "blockquote",
    "h1", "h2", "h3", "h4",
  ],
  ALLOWED_ATTR: ["href", "target", "rel"],
  // Force safe link behaviour — external targets open in new tab with noopener.
  ADD_ATTR: ["target", "rel"],
};

export function sanitizeHtml(html) {
  if (typeof html !== "string") return "";
  const clean = DOMPurify.sanitize(html, CONFIG);
  // Ensure any <a> we DID allow has rel="noopener noreferrer".
  return clean.replace(/<a /g, '<a rel="noopener noreferrer" target="_blank" ');
}
